module.exports = __webpack_public_path__ + "img/1.148be367.png";